// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2045":"ef798f337778807c","2708":"ae5bc51b7807ce0d","6312":"bbf68f80edd8e272","8098":"6d946dbfdc36470e"}[chunkId] + ".js";
};